import FeCourse from './feCourse'
export default class FeSubject {
    /**
     * @type {string}
     * @memberof FeSubject
     * @name 科目主键(科目ID)
     */
    public subjectId: string;
    /**
     * @type {string}
     * @memberof FeSubject
     * @name 编号
     */
    public no: string;
    /**
     * @type {string}
     * @memberof FeSubject
     * @name 名称
     */
    public name: string;
    /**
     * @type {string}
     * @memberof FeSubject
     * @name 领域名称
     */
    public domain: string;
    /**
     * @type {string}
     * @memberof FeSubject
     * @name 排序字段
     */
    public sortSeq: string;
    /**
     * @type {string}
     * @memberof FeSubject
     * @name 学段常量,多个学段用逗号分隔（小学，初中，高中），空代表全学段
     */
    public studySections: string;
    /**
     * @type {FeCourse[]}
     * @memberof FeSubject
     * @name 科目主键(科目ID)
     */
    public courseList: FeCourse[];
    constructor({
        subjectId = '',
        no = '',
        name = '',
        domain = '',
        sortSeq = '',
        studySections = '',
        courseList = []
    } = {}) {
        this.subjectId = subjectId,
        this.no = no,
        this.name = name,
        this.domain = domain,
        this.sortSeq = sortSeq,
        this.studySections = studySections,
        this.courseList = courseList
    }
}